import React, { useEffect, useState } from "react";
import { useDebounce } from 'use-debounce';

const InputSearch = ({onChange, placeholder, minLength, timeout, id, name, className, type}) => {
    const [filter, setFilter] = useState('');
    const [value] = useDebounce(filter, timeout ? timeout : 1000);
    
    useEffect(() => {
      if(onChange) {
        const minValueLength = minLength ? minLength : 0;

        if(value.length > minValueLength) {
          onChange(value)
        } else {
          onChange(null)
        }
      }
    }, [value, minLength, onChange])

    return (
      
        <input
          type={type ? type : "text"}
          id={id ? id : ""}
          name={name ? name : ""}
          className={className ? className : "form-control"}
          placeholder={placeholder ? placeholder : "Search ..."}
          onChange={(e) => {
            setFilter(e.target.value);
          }}
          defaultValue={filter}
        />
      
    );
};

export default InputSearch;